(() => {
  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const dialog = root.querySelector('dialog');
    const status = root.querySelector('[data-download-status]');
    let opener, current = 0;
    const photos = [...root.querySelectorAll('[data-photo]')];
    const visiblePhotos = () => photos.filter(photo => !photo.closest('[data-category]').hidden);
    function show(photo) {
      const items = visiblePhotos(); current = items.indexOf(photo);
      const img = photo.querySelector('img');
      const full = dialog.querySelector('img');
      full.src = photo.dataset.preview; full.alt = img.alt;
      dialog.querySelector('[data-dialog-title]').textContent = img.alt;
      const download = dialog.querySelector('[data-download]');
      download.href = photo.querySelector('[data-download]').href;
      download.download = photo.querySelector('[data-download]').download;
      dialog.querySelector('[data-position]').textContent = `${current + 1} / ${items.length}`;
    }
    function filter(value) {
      root.querySelectorAll('[data-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === value)));
      root.querySelectorAll('[data-category]').forEach(group => group.hidden = value !== 'all' && group.dataset.category !== value);
      root.querySelector('[data-category-select]').value = value;
      status.textContent = `${visiblePhotos().length} photos`;
    }
    root.querySelectorAll('[data-filter]').forEach(button => button.addEventListener('click', () => filter(button.dataset.filter)));
    root.querySelector('[data-category-select]').addEventListener('change', event => filter(event.target.value));
    photos.forEach(photo => photo.querySelector('button').addEventListener('click', event => {
      opener = event.currentTarget; show(photo); dialog.showModal();
    }));
    dialog.querySelector('[data-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => { dialog.querySelector('img').removeAttribute('src'); opener?.focus(); });
    function step(amount) { const items = visiblePhotos(); show(items[(current + amount + items.length) % items.length]); }
    dialog.querySelector('[data-prev]').addEventListener('click', () => step(-1));
    dialog.querySelector('[data-next]').addEventListener('click', () => step(1));
    dialog.addEventListener('keydown', event => { if (event.key === 'ArrowLeft') step(-1); if (event.key === 'ArrowRight') step(1); });
    root.querySelectorAll('[data-download]').forEach(link => link.addEventListener('click', async event => {
      event.preventDefault(); if (link.getAttribute('aria-busy') === 'true') return;
      link.setAttribute('aria-busy', 'true');
      const old = link.textContent; link.textContent = 'Downloading…';
      try {
        const response = await fetch(link.href);
        if (!response.ok) throw new Error('Download failed');
        const archive = await response.arrayBuffer();
        const header = new DataView(archive);
        // The download archives contain one unchanged JPEG using ZIP_STORED.
        // Read that JPEG in the browser so visitors receive a normal photo file.
        if (header.byteLength < 30 || header.getUint32(0, true) !== 0x04034b50 || header.getUint16(8, true) !== 0) throw new Error('Invalid photo archive');
        const start = 30 + header.getUint16(26, true) + header.getUint16(28, true);
        const size = header.getUint32(18, true);
        if (!size || start + size > archive.byteLength) throw new Error('Incomplete photo archive');
        const blob = new Blob([archive.slice(start, start + size)], { type: 'image/jpeg' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a'); a.href = url; a.download = link.download.replace(/\.zip$/i, '.jpg');
        document.body.append(a); a.click(); a.remove(); setTimeout(() => URL.revokeObjectURL(url), 60000);
        status.textContent = 'Your original photo is ready. Check your downloads.';
      } catch {
        status.textContent = 'Open the downloaded ZIP to save your original JPEG photo.';
        window.open(link.href, '_blank', 'noopener');
      } finally { link.removeAttribute('aria-busy'); link.textContent = old; }
    }));
  }
  document.querySelectorAll('[data-lille-gallery]').forEach(init);
  document.addEventListener('shopify:section:load', event => init(event.target.querySelector('[data-lille-gallery]')));
})();
